import React from 'react';
import { motion } from 'framer-motion';
import { Calendar, ExternalLink } from 'lucide-react';

export const ClientCard = ({ client, hubspotStatus, onClick }) => (
  <motion.div
    layout
    initial={{ opacity: 0, y: 10 }}
    animate={{ opacity: 1, y: 0 }}
    className="bg-[#0a0a0a] border border-white/10 p-4 cursor-pointer hover:border-white/20"
    onClick={onClick}
    data-testid={`crm-client-${client.crm_id}`}
  >
    <h4 className="text-white font-medium mb-1 truncate">{client.name}</h4>
    <p className="text-white/60 text-xs truncate">{client.event_type}</p>
    <div className="flex items-center gap-2 mt-2 text-white/40 text-xs">
      {client.event_date && (
        <span className="flex items-center gap-1">
          <Calendar size={12} />
          {client.event_date}
        </span>
      )}
    </div>
    {client.budget_range && (
      <div className="mt-2">
        <span className="text-xs bg-[#D4AF37]/20 text-[#D4AF37] px-2 py-0.5">
          {client.budget_range}
        </span>
      </div>
    )}
    {client.hubspot_deal_id && hubspotStatus?.portal_id && (
      <a
        href={`https://app.hubspot.com/contacts/${hubspotStatus.portal_id}/record/0-3/${client.hubspot_deal_id}`}
        target="_blank"
        rel="noopener noreferrer"
        onClick={(e) => e.stopPropagation()}
        className="inline-flex items-center gap-1 mt-3 text-[#FF7A59] hover:text-[#FF9B82] text-[10px] uppercase tracking-widest"
        data-testid={`crm-card-hubspot-${client.crm_id}`}
        title="Open this deal in HubSpot"
      >
        <ExternalLink size={10} />
        HubSpot
      </a>
    )}
  </motion.div>
);
